export default "__VITE_ASSET__UBDPuQWl__"